
import { isAlphanumericAllSpecialCharacters } from "../../../functions/validations";

export const WPS_Input = (({ valuefield, maxLength, isReadonly, handleChange, status, errObj, id, required, action, setErrorObj, allowlistfunction,
  allowcharacters,
  customMessage }) => {
  let err = Array.isArray(status) ? status.filter(item => item.id === id) : []

  const getInputClassName = () => {
    if (required === "Required" && err.length !== 0) {
      return "error-input";
    }
    return "";
  };

  return (<>
    {required === "None" ?
      <span>-</span>
      :
      <input
        type="text"
        className={getInputClassName()}
        id={id}
        readOnly={
          action === "Copy"
            ? isReadonly
            : false
        }
        name={id}
        maxLength={maxLength}
        placeholder=" "
        value={
          required === "None"
            ? "-"
            : valuefield
        }
        onChange={handleChange}
        onInput={(e) => {
          let error = allowlistfunction ? allowlistfunction(e.target.value, allowcharacters, customMessage) : isAlphanumericAllSpecialCharacters(e.target.value);
          let msg = ""
          if (error.status) {
            msg = error.message
            let changeError = Array.isArray(status) ? [...status] : []
            let found = false
            for (const i of changeError) {
              if (i.id == id) {
                i.msg = msg
                found = true
              }
            }
            if (!found)
              changeError.push({ id: id, msg: msg })
            setErrorObj(changeError)
          }
          else {
            setErrorObj((status) => Array.isArray(status) ? status.filter(i => i.id !== id) : []);
          }
        }
        }
      />
    }</>)
})